import moment from 'moment';
import { NewsSearchGeneralTypes } from './news-search.types';
import { compareValues } from '../../utilities/CommonUtilities';

const NEWS_SEARCH_GENERAL_DATA = {
  lastSearchData: {},
  currentSearchData: {},
};

export const generalNewsSearchData = (
  state = NEWS_SEARCH_GENERAL_DATA,
  action
) => {
  switch (action.type) {
    case NewsSearchGeneralTypes.NEWS_SEARCH_GENERAL:
      if (action.payload) {
        const payloadData = action.payload;

        const totalDocumentCount = action.payload['@odata.count'];
        const searchFacetsObject = payloadData['@search.facets'];

        let preparedSearchFacets = [];
        let preparedObject = {};
        let datePublished = {};

        if (searchFacetsObject) {
          datePublished = {
            startDate: moment('1975-03-04T10:57:02.444Z'),
            endDate: moment().toISOString(),
          };

          preparedSearchFacets = Object.keys(searchFacetsObject)
            .filter((e) => e !== 'DatePublished')
            .map((e) => {
              const value = searchFacetsObject[e].filter(
                (element) => element.value.length !== 0
              );
              return {
                key: e,
                value, // .sort(compareValues('count', 'desc'))
              };
            })
            .sort(compareValues('key', 'desc'));
        }

        preparedObject = {
          ...preparedObject,
          ...action.payload,
          totalDocumentCount,
          preparedSearchFacets,
          datePublished,
        };
        return {
          ...state,
          currentSearchData: preparedObject,
        };
      }
      return {
        ...state,
      };

    case NewsSearchGeneralTypes.NEWS_SEARCH_GENERAL_LAST_SEARCH:
      if (action.payload) {
        return {
          ...state,
          lastSearchData: action.payload,
        };
      }
      return {
        ...state,
      };

    default:
      return state;
  }
};
